import ReactToPrint from 'react-to-print';
import { BASE_URL, FRONTEND_URL } from "../../../config/axios";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import axios from "axios";
import { formattedDate, formattedDateLong } from '../../Date';
import numberToWords from 'number-to-words';
import { ExpenseDetailApproved, ExpenseDetailPartialApproved, ExpenseDetailReject, BillAuthentication, ViewBill, TLExpenseApprove, TLExpenseReject, AccountAExpenseApprove, AccountAExpenseReject, AdminExpenseApprove, AdminExpenseReject, AccountAPartialEdit } from './ExpenseSlipComponents';
import { PendingCheckBox, Printer } from '../../AllSvg';
import { formatRoundoff2D } from '../../CustomFunctions';
import { DynamicRequestExpenseApproval, DynamicRequestExpenseFinalize, DynamicRequestExpensePartialEdit, DynamicRequestExpenseRejection } from '../../settings/DynamicApprovalProcess/DynamicApprovalComponents';
import { AlertCircle, ArrowLeft, CheckCircle2, Clock, FileText, Wallet } from 'lucide-react';
import './expenseSlip.css'



const ExpenseSlip = React.forwardRef((props, ref) => {
  const { getRequestActionData, ...otherProps } = props;

  let { id } = useParams();
  const location = useLocation();
  const opener = location.state ? location.state.opener : "";
  const requestData = location.state ? location.state.reqData : null;

  const [imprestData, setImprestData] = useState({})
  const [expenseData, setExpenseData] = useState([])
  const [expenseDetailsData, setExpenseDetailsData] = useState([])
  const [personalData, setPersonalData] = useState({})

  const nextApproval = requestData.expense_details.dynamic_approval.find(
    (approval) => approval.level === requestData.level + 1
  );
  const shouldShowButtons =
    !nextApproval ||
    nextApproval.approval_status !== 'approved';

  const totalImprestAsked = Number(requestData.expense_details.imprest_data?.grocery) + Number(requestData.expense_details.imprest_data?.stationary_item) + Number(requestData.expense_details.imprest_data?.electronic_item) + Number(requestData.expense_details.imprest_data?.fixed_imprest_amount) +
    (requestData.expense_details.imprest_data?.other_details?.length > 0
      ? requestData.expense_details.imprest_data?.other_details.reduce((total, other) => total + Number(other.amount || 0), 0)
      : 0);
  const totalImprestAskedWords = numberToWords.toWords(totalImprestAsked ? totalImprestAsked : 0);

  const totalImprestApproved = Number(requestData.expense_details.imprest_data?.approved_grocery) + Number(requestData.expense_details.imprest_data?.approved_stationary_item) + Number(requestData.expense_details.imprest_data?.approved_electronic_item) + Number(requestData.expense_details.imprest_data?.approved_project_imprest_monthly) +
    (requestData.expense_details.imprest_data?.other_details?.length > 0
      ? requestData.expense_details.imprest_data?.other_details.reduce((total, other) => total + Number(other.approved_other || 0), 0)
      : 0);
  const totalImprestApprovedWords = numberToWords.toWords(totalImprestApproved ? totalImprestApproved : 0);

  const [expensesum, setExpenseSum] = useState(0)
  const [sum, setSum] = useState(0)
  const [dates, setDates] = useState(0)

  const [groceryTotal, setGroceryTotal] = useState(0);
  const [stationaryTotal, setStationaryTotal] = useState(0);
  const [electronicTotal, setElectronicTotal] = useState(0);
  const [otherTotal, setOtherTotal] = useState(0);

  const [approvedGroceryTotal, setApprovedGroceryTotal] = useState(0);
  const [approvedStationaryTotal, setApprovedStationaryTotal] = useState(0);
  const [approvedElectronicTotal, setApprovedElectronicTotal] = useState(0);
  const [approvedOtherTotal, setApprovedOtherTotal] = useState(0);
  const [amountsApproved, setAmountsApproved] = useState(false)

  const [buffer, setBuffering] = useState(true); //buffering logic

  const getPageData = async () => {
    setBuffering(true); // Start Buffering
    try {
      const exp = await axios.get(`${BASE_URL}/siteproject/expensebyid/${id}/`);
      setExpenseData(exp.data)

      const res = await axios.get(`${BASE_URL}/siteproject/expensedetailsbyexpense/${exp.data.id}/`);
      setExpenseDetailsData(res.data)
      setDates(res.data.map(item => item.date).sort((a, b) => new Date(a) - new Date(b)));
      setAmountsApproved(res.data.some(expense => expense.bill_approved_amt === null))

      const summ = res.data.some(expense => expense.bill_approved_amt === null)
        ? res.data.reduce((acc, item) => acc + parseFloat(item.item_amount || 0), 0)
        : res.data.reduce((acc, item) => acc + parseFloat(item.bill_approved_amt || 0), 0);
      setSum(summ)

      const expsumm = res.data.reduce((acc, item) => acc + parseFloat(item.item_amount), 0);
      setExpenseSum(expsumm)

      res.data.forEach(item => {
        const amount = Number(item.item_amount);
        const approvedAmount = Number(item.bill_approved_amt);

        const isOtherItem = exp.data.imprest_data?.other_details?.some(
          other => other.other_name === item.expense_type
        );

        if (isOtherItem) {
          setOtherTotal(prevTotal => prevTotal + amount);
          setApprovedOtherTotal(prevTotal => prevTotal + (approvedAmount || 0));
        } else {
          switch (item.expense_type) {
            case 'Grocery':
              setGroceryTotal(prevTotal => prevTotal + amount);
              setApprovedGroceryTotal(prevTotal => prevTotal + approvedAmount);
              break;
            case 'Stationary':
              setStationaryTotal(prevTotal => prevTotal + amount);
              setApprovedStationaryTotal(prevTotal => prevTotal + approvedAmount);
              break;
            case 'Electronic':
              setElectronicTotal(prevTotal => prevTotal + amount);
              setApprovedElectronicTotal(prevTotal => prevTotal + approvedAmount);
              break;
            default:
              setOtherTotal(prevTotal => prevTotal + amount);
              setApprovedOtherTotal(prevTotal => prevTotal + (approvedAmount || 0));
              break;
          }
        }
      });

      const ress = await axios.get(`${BASE_URL}/siteproject/employeebyempid/${exp.data.emp_account_detail}/`)
      setPersonalData(ress.data)

      const resss = await axios.get(`${BASE_URL}/siteproject/imprestbyid/${exp.data.imprest}/`)
      setImprestData(resss.data)

    } catch (err) {
    } finally {
      setBuffering(false); // End Buffering
    }
  };

  useEffect(() => {
    getPageData();
  }, []);

  const expenseAskedByType = expenseDetailsData.reduce((acc, item) => {
    const type = item.expense_type;
    const amount = parseFloat(item.item_amount) || 0;
    acc[type] = (acc[type] || 0) + amount;
    return acc;
  }, {});

  const expenseApprovedByType = expenseDetailsData.reduce((acc, item) => {
    const type = item.expense_type;
    const amount = parseFloat(item.bill_approved_amt) || 0;
    acc[type] = (acc[type] || 0) + amount;
    return acc;
  }, {});

  return (
    <div className='' ref={ref}>
      <style>{`
        .expslip-card {
          border: 1px solid #e5e7eb;
          border-radius: 16px;
          overflow: hidden;
          background: white;
          position: relative;
        }
        .expslip-card-header {
          background: linear-gradient(180deg, #0f172a 0%, #1e293b 100%) !important;
          padding: 20px 24px;
          color: white;
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 10px;
        }
        .expslip-header-left {
          display: flex;
          align-items: center;
          gap: 14px;
        }
        .expslip-logo {
          height: 40px;
          width: auto;
          background: white;
          border-radius: 6px;
          padding: 4px;
        }
        .expslip-header-title {
          font-size: 17px;
          font-weight: 700;
          margin: 0;
        }
        .expslip-header-sub {
          font-size: 12.5px;
          opacity: 0.9;
          margin: 2px 0 0;
        }
        .expslip-badge {
          background: rgba(255,255,255,0.2);
          padding: 5px 12px;
          border-radius: 999px;
          font-size: 12px;
          font-weight: 600;
          white-space: nowrap;
          text-align: right;
          line-height: 1.4;
        }
        .expslip-body {
          padding: 22px 24px;
        }
        .expslip-info-grid {
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          gap: 14px 24px;
          margin-bottom: 18px;
        }
        .expslip-info-item {
          display: flex;
          flex-direction: column;
          gap: 3px;
        }
        .expslip-info-label {
          font-size: 11.5px;
          font-weight: 600;
          color: #94a3b8;
          text-transform: uppercase;
          letter-spacing: 0.4px;
        }
        .expslip-info-value {
          font-size: 14px;
          color: #1f2937;
          font-weight: 600;
        }
        .expslip-section-title {
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 13px;
          font-weight: 700;
          color: #475569;
          margin: 18px 0 10px;
          text-transform: uppercase;
          letter-spacing: 0.4px;
        }
        .expslip-table-wrap {
          background: #f8fafc;
          border: 1px solid #e5e7eb;
          border-radius: 12px;
          padding: 6px 10px;
          overflow-x: auto;
        }
        .expslip-table {
          width: 100%;
          border-collapse: collapse;
        }
        .expslip-table thead th {
          font-size: 11.5px;
          font-weight: 600;
          color: #94a3b8;
          text-transform: uppercase;
          letter-spacing: 0.3px;
          padding: 8px 10px;
          text-align: left;
          border-bottom: 1px dashed #e2e8f0;
        }
        .expslip-table tbody td {
          font-size: 13.5px;
          color: #475569;
          padding: 8px 10px;
        }
        .expslip-table tbody tr:not(:last-child) td {
          border-bottom: 1px dashed #e2e8f0;
        }
        .expslip-row-label {
          font-weight: 700;
          color: #1f2937;
        }
        .expslip-total-cell {
          font-weight: 700;
          color: #1f2937;
        }
        .expslip-total-row {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 14px;
          background: #f8fafc;
          border: 1px solid #e5e7eb;
          border-radius: 12px;
          padding: 12px 18px;
          margin-top: 10px;
        }
        .expslip-total-row .expslip-info-item {
          min-width: 200px;
        }
        .uppercase {
          text-transform: uppercase;
        }
        .expslip-detail-table {
          width: 100%;
          border-collapse: collapse;
          margin-top: 8px;
        }
        .expslip-detail-table thead th {
          font-size: 11.5px;
          font-weight: 600;
          color: #94a3b8;
          text-transform: uppercase;
          letter-spacing: 0.3px;
          padding: 8px 10px;
          text-align: left;
          border-bottom: 1px solid #e2e8f0;
        }
        .expslip-detail-table tbody td {
          font-size: 13.5px;
          color: #475569;
          padding: 9px 10px;
          border-bottom: 1px dashed #e2e8f0;
        }
        .expslip-status-approved {
          color: #16a34a;
          font-weight: 700;
        }
        .expslip-status-rejected {
          color: #dc2626;
          font-weight: 700;
        }
        .expslip-footer-note {
          text-align: center;
          font-size: 11px;
          color: #94a3b8;
          margin-top: 20px;
          padding-top: 14px;
          border-top: 1px dashed #e2e8f0;
        }
        @media print {
          .expslip-card {
            border: none;
          }
          .expslip-card-header {
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }
        }
      `}</style>

      <div className='expslip-card'>
        {buffer ? <div className="spinner-bgdatil"></div> : null}

        <div className='expslip-card-header'>
          <div className='expslip-header-left'>
            <div>
              <h3 className='expslip-header-title'>Expense Slip</h3>
              <p className='expslip-header-sub'>{expenseData.name}</p>
            </div>
          </div>

        </div>

        <div className='expslip-body'>
          <div className='expslip-info-grid'>
            <div className='expslip-info-item'>
              <span className='expslip-info-label'>Project Name</span>
              <span className='expslip-info-value'>{expenseData.project_name}</span>
            </div>
            <div className='expslip-info-item'>
              <span className='expslip-info-label'>Employee Code</span>
              <span className='expslip-info-value'>{personalData.emp_code}</span>
            </div>
            <div className='expslip-info-item'>
              <span className='expslip-info-label'>Designation</span>
              <span className='expslip-info-value'>{personalData.designation_name}</span>
            </div>
            <div className='expslip-info-item'>
              <span className='expslip-info-label'>Name</span>
              <span className='expslip-info-value'>{personalData.name}</span>
            </div>
            <div className='expslip-info-item'>
              <span className='expslip-info-label'>Start Date</span>
              <span className='expslip-info-value'>{dates.length === 0 ? "Expense Details Pending" : formattedDateLong(dates[0])}</span>
            </div>
            <div className='expslip-info-item'>
              <span className='expslip-info-label'>End Date</span>
              <span className='expslip-info-value'>{dates.length === 0 ? "Expense Details Pending" : formattedDateLong(dates[dates.length - 1])}</span>
            </div>
          </div>

          {/* Imprest Section */}
          <div className='expslip-section-title'><Wallet size={14} /> Imprest</div>
          <div className='expslip-table-wrap'>
            <table className='expslip-table'>
              <thead>
                <tr>
                  <th></th>
                  {Number(imprestData.stationary_item) > 0 && <th>Stationary</th>}
                  {Number(imprestData.grocery) > 0 && <th>Grocery</th>}
                  {Number(imprestData.approved_project_imprest_monthly) > 0 && <th>Fixed Site Imprest</th>}
                  {Number(imprestData.electronic_item) > 0 && <th>Electronics</th>}
                  {imprestData.other_details?.length > 0 && imprestData.other_details.map((other, index) => (
                    <th key={index} className='uppercase'>{other.other_name ? other.other_name : `Other-${index + 1}`}</th>
                  ))}
                  <th>Grand Total</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className='expslip-row-label'>Asked</td>
                  {Number(imprestData.stationary_item) > 0 && <td>{formatRoundoff2D(imprestData.stationary_item)}</td>}
                  {Number(imprestData.grocery) > 0 && <td>{formatRoundoff2D(imprestData.grocery)}</td>}
                  {Number(imprestData.approved_project_imprest_monthly) > 0 && <td>{formatRoundoff2D(imprestData.fixed_imprest_amount)}</td>}
                  {Number(imprestData.electronic_item) > 0 && <td>{formatRoundoff2D(imprestData.electronic_item)}</td>}
                  {imprestData.other_details?.length > 0 && imprestData.other_details.map((other, index) => (
                    <td key={index}>{formatRoundoff2D(other.amount || 0)}</td>
                  ))}
                  <td className='expslip-total-cell'>{formatRoundoff2D(totalImprestAsked)}</td>
                </tr>
                <tr>
                  <td className='expslip-row-label'>Approved</td>
                  {Number(imprestData.approved_project_imprest_monthly) > 0 && <td>{formatRoundoff2D(imprestData.approved_project_imprest_monthly)}</td>}
                  {Number(imprestData.grocery) > 0 && <td>{formatRoundoff2D(imprestData.approved_grocery)}</td>}
                  {Number(imprestData.stationary_item) > 0 && <td>{formatRoundoff2D(imprestData.approved_stationary_item)}</td>}
                  {Number(imprestData.electronic_item) > 0 && <td>{formatRoundoff2D(imprestData.approved_electronic_item)}</td>}
                  {imprestData.other_details?.length > 0 && imprestData.other_details.map((other, index) => (
                    <td key={index}>{formatRoundoff2D(other.approved_other || 0)}</td>
                  ))}
                  <td className='expslip-total-cell'>{formatRoundoff2D(totalImprestApproved)}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className='expslip-total-row'>
            <div className='expslip-info-item'>
              <span className='expslip-info-label'>Grand Total</span>
              <span className='expslip-info-value'>{formatRoundoff2D(totalImprestApproved)}</span>
            </div>
            <div className='expslip-info-item'>
              <span className='expslip-info-label'>In Words</span>
              <span className='expslip-info-value uppercase'>{totalImprestApprovedWords}</span>
            </div>
          </div>

          {/* Expense Summary Section */}
          <div className='expslip-section-title'><Wallet size={14} /> Expense</div>
          <div className='expslip-table-wrap'>
            <table className='expslip-table'>
              <thead>
                <tr>
                  <th></th>
                  {Object.keys(expenseAskedByType).map((expenseType) => (
                    <th key={expenseType}>{expenseType}</th>
                  ))}
                  <th>Grand Total</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className='expslip-row-label'>Asked</td>
                  {Object.entries(expenseAskedByType).map(([expenseType, totalAmount]) => (
                    <td key={expenseType}>{formatRoundoff2D(totalAmount)}</td>
                  ))}
                  <td className='expslip-total-cell'>{formatRoundoff2D(expensesum)}</td>
                </tr>
                <tr>
                  <td className='expslip-row-label'>Approved</td>
                  {Object.entries(expenseApprovedByType).map(([expenseType, totalAmount]) => (
                    <td key={expenseType}>{formatRoundoff2D(totalAmount)}</td>
                  ))}
                  <td className={amountsApproved ? 'expslip-status-rejected' : 'expslip-total-cell'}>
                    {amountsApproved ? "Approvals Pending" : formatRoundoff2D(sum)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Detailed line items */}
          <div className='expslip-section-title'>Expense Details</div>
          <table className='expslip-detail-table'>
            <thead>
              <tr>
                <th>Sr No.</th>
                <th>Date</th>
                <th>Name</th>
                <th>Amount</th>
                <th>Approved Amt.</th>
                <th>Bills</th>
              </tr>
            </thead>
            <tbody>
              {expenseDetailsData
                .sort((a, b) => new Date(a.date) - new Date(b.date))
                .map((j, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{formattedDateLong(j.date)}</td>
                    <td>{j.item_name}</td>
                    <td>{j.item_amount}</td>
                    <td
                      title={`${j.bill_amount_change_reason ? `Amount Change Reason: \n${j.bill_amount_change_reason}` : ""}`}
                      style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}
                    >
                      {j.bill_approved_amt ?
                        Number(j.bill_approved_amt) === 0 && j.bill_approved === "rejected" ?
                          <span
                            title={`${j.bill_amount_change_reason ? `Amount Change Reason: \n${j.bill_amount_change_reason}\n` : ""}${j.bill_approved === "rejected" ? `Bill Reject Reason: \n${j.bill_rejection_reason}` : ""}`}
                            style={{ textDecoration: 'line-through' }}
                          >
                            {j.authority_approved_amt}
                          </span>
                          : j.bill_approved_amt
                        :
                        buffer ? <div className="spinner-vsmall"></div> :
                          requestData.permissions === 'Approve-Reject-Edit' && shouldShowButtons ?
                            <ExpenseDetailApproved i={j} getExpensedetail={getPageData} />
                            :
                            "-"
                      }
                      {requestData.permissions === 'Approve-Reject-Edit' && shouldShowButtons &&
                        <ExpenseDetailPartialApproved i={j} getExpensedetail={getPageData} />
                      }
                    </td>
                    <td style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                      {j.bill ?
                        requestData.permissions === 'Approve-Reject-Edit' && requestData.approval_status === "pending" && requestData.role?.role_name === "Account" ?
                          buffer ? <div className="spinner-vsmall"></div> :
                            <BillAuthentication i={j} getExpenseDetail={getPageData} getRequestActionData={getRequestActionData} />
                          :
                          <>
                            <ViewBill i={j} />
                            {expenseData.dynamic_approval?.some(da => da.permissions === "Approve-Reject-Edit" && da.approval_status !== "pending") ?
                              j.bill_approved !== "pending" ?
                                j.bill_approved === "approved" ?
                                  <span title="Bill Approved" className="expslip-status-approved">✓</span>
                                  : <span
                                    title={`Bill Rejection Reason: \n${j.bill_rejection_reason}`}
                                    className="expslip-status-rejected"
                                  >
                                    ✕
                                  </span>
                                :
                                <div title='Bill Check Pending'>
                                  <PendingCheckBox color={"#707070"} />
                                </div>
                              : null
                            }
                          </>
                        : "No bill"}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>

          <div className='expslip-total-row'>
            <div className='expslip-info-item'>
              <span className='expslip-info-label'>Total</span>
              <span className='expslip-info-value'>{formatRoundoff2D(sum)}</span>
            </div>
            <div className='expslip-info-item'>
              <span className='expslip-info-label'>In Words</span>
              <span className='expslip-info-value uppercase'>{numberToWords.toWords(sum)}</span>
            </div>
          </div>

          <p className='expslip-footer-note'>*This is Software generated Expense Slip no signature required*</p>
        </div>
      </div>
    </div>
  )
});

const ExpenseSlipByRequest = () => {
  let { id } = useParams();
  const location = useLocation();
  const requestData = location.state ? location.state.reqData : null;

  const ref = useRef();
  const navigate = useNavigate()
  const currentUrl = window.location.href;
  const urlParts = currentUrl.split('/');
  let backUrl = "/" + urlParts[3] + `/requestManagement`;

  let requesttoggle = 4;
  let expenseStage = requestData.level;

  const nextApproval = requestData.expense_details.dynamic_approval.find(
    (approval) => approval.level === requestData.level + 1
  );
  const previousApproval = requestData.expense_details.dynamic_approval.find(
    (approval) => approval.level === requestData.level - 1
  );

  const nextStageBlocked = nextApproval && nextApproval.approval_status === 'approved';
  const previousStagePending = previousApproval &&
    (previousApproval.approval_status === 'pending' || previousApproval.approval_status === 'rejected');
  const shouldShowButtons =
    (!nextApproval || nextApproval.approval_status !== 'approved') &&
    (!previousApproval || previousApproval.approval_status === 'approved');

  const handleBackRouteToRequests = () => {
    navigate(backUrl, {
      state: {
        requesttoggle,
        expenseStage
      }
    });
  }

  const backroute = (requesttoggle, expenseStage) => {
    navigate(backUrl, { state: { requesttoggle, expenseStage }, replace: true })
  }

  const [expenseData, setExpenseData] = useState([])
  const [expenseDataDetails, setExpenseDataDetails] = useState([])

  const [amountsApproved, setAmountsApproved] = useState(false)
  const [billAuthenticated, setBillAuthenticated] = useState(false)

  const [buffer, setBuffering] = useState(true); //buffering logic

  const getExpenseData = async () => {
    setBuffering(true); // Start Buffering
    try {
      const exp = await axios.get(`${BASE_URL}/siteproject/expensebyid/${id}/`);
      setExpenseData(exp.data)

      const expdeat = await axios.get(`${BASE_URL}/siteproject/expensedetailsbyexpense/${exp.data.id}/`);
      setExpenseDataDetails(expdeat.data)
      setAmountsApproved(expdeat.data.some(expense => expense.bill_approved_amt === null))
      setBillAuthenticated(expdeat.data.some(expense => expense.bill_approved === "pending"))
    } catch (err) {
    } finally {
      setBuffering(false); // End Buffering
    }
  };
  useEffect(() => {
    getExpenseData();
  }, []);

  return (
    <>
      <style>{`
          .esr-page {
              display: flex;
              flex-direction: column;
              align-items: center;
              gap: 16px;
              padding: 20px 16px 40px;
          }
          .esr-topbar-card {
              width: 100%;
              max-width: 820px;
              border-radius: 16px;
              overflow: hidden;
              border: 1px solid #e5e7eb;
          }
          .esr-topbar-header {
              background: linear-gradient(180deg, #0f172a 0%, #1e293b 100%);
              padding: 18px 24px;
              color: white;
              display: flex;
              align-items: center;
              justify-content: space-between;
              flex-wrap: wrap;
              gap: 10px;
          }
          .esr-topbar-title-group {
              display: flex;
              align-items: center;
              gap: 10px;
          }
          .esr-topbar-title {
              font-size: 17px;
              font-weight: 700;
              margin: 0;
          }
          .esr-topbar-sub {
              font-size: 12px;
              opacity: 0.85;
              margin: 2px 0 0;
          }
          .esr-topbar-actions {
              display: flex;
              align-items: center;
              gap: 10px;
          }
          .esr-back-btn {
              display: flex;
              align-items: center;
              gap: 6px;
              background: rgba(255,255,255,0.12);
              border: 1px solid rgba(255,255,255,0.25);
              color: white;
              border-radius: 10px;
              padding: 9px 16px;
              font-size: 13px;
              font-weight: 600;
              cursor: pointer;
              transition: background 0.15s ease;
          }
          .esr-back-btn:hover {
              background: rgba(255,255,255,0.2);
          }
          .esr-print-btn {
              display: flex;
              align-items: center;
              gap: 8px;
              background: white;
              color: #0f172a;
              border: none;
              border-radius: 10px;
              padding: 9px 18px;
              font-size: 13px;
              font-weight: 700;
              cursor: pointer;
              transition: opacity 0.15s ease;
          }
          .esr-print-btn:hover {
              opacity: 0.9;
          }
          .esr-action-body {
              background: white;
              padding: 18px 24px;
          }
          .esr-action-group {
              display: flex;
              align-items: center;
              justify-content: center;
              flex-wrap: wrap;
              gap: 10px;
          }
          .esr-status-banner {
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 8px;
              background: #f8fafc;
              border: 1px solid #e5e7eb;
              border-radius: 10px;
              padding: 10px 16px;
              font-size: 13px;
              font-weight: 600;
              color: #475569;
              width: 100%;
          }
          .esr-status-banner.warning {
              background: #fff7ed;
              color: #c2410c;
              border-color: #fed7aa;
          }
          .esr-status-banner.info {
              background: #eff6ff;
              color: #1d4ed8;
              border-color: #bfdbfe;
          }
          .esr-status-banner.success {
              background: #f0fdf4;
              color: #15803d;
              border-color: #bbf7d0;
          }
          .esr-divider-row {
              display: flex;
              flex-direction: column;
              align-items: center;
              gap: 10px;
              width: 100%;
          }
      `}</style>

      <div className="esr-page">

        <div className="esr-topbar-card">
          <div>

            <div className="esr-topbar-actions">
              <button className="esr-back-btn" style={{ background: "black" }} onClick={(e) => { backroute(requesttoggle, expenseStage) }}>
                <ArrowLeft size={15} />
                Back
              </button>
              <ReactToPrint
                bodyClass="print-agreement"
                content={() => ref.current}
                trigger={() => (
                  <button className="esr-print-btn">
                    <Printer size={15} />
                    Print
                  </button>
                )}
              />
            </div>
          </div>

          <div className="esr-action-body">
            {buffer ? (
              <div className="loader-minimal"><div className="spinner-minimal"></div></div>
            ) : (
              <div className="esr-divider-row">
                <ExpenseSlip ref={ref} getRequestActionData={getExpenseData} />

                {shouldShowButtons ? (
                  <>
                    {!amountsApproved ? (
                      (requestData.approval_status === 'pending' || requestData.approval_status === 'rejected') && (
                        <div className="esr-action-group">
                          {requestData.permissions !== 'Finalize' &&
                            !(requestData.permissions === 'Approve-Reject-Edit' && requestData.role?.role_name === "Account") && (
                              <DynamicRequestExpenseApproval i={expenseData} j={expenseDataDetails} k={requestData} getExpenseData={getExpenseData} handleBackRoute={handleBackRouteToRequests} />
                            )}

                          {requestData.permissions === 'Finalize' &&
                            <DynamicRequestExpenseFinalize i={expenseData} j={expenseDataDetails} k={requestData} getExpenseData={getExpenseData} handleBackRoute={handleBackRouteToRequests} />
                          }

                          {requestData.permissions === 'Approve-Reject-Edit' &&
                            requestData.role?.role_name === "Account" && (
                              <>
                                {billAuthenticated ? (
                                  <div className="esr-status-banner warning">
                                    <AlertCircle size={15} />
                                    Please verify all bills before approval
                                  </div>
                                ) : (
                                  <DynamicRequestExpenseApproval i={expenseData} j={expenseDataDetails} k={requestData} getExpenseData={getExpenseData} handleBackRoute={handleBackRouteToRequests} />
                                )}
                                <DynamicRequestExpensePartialEdit i={expenseData} j={expenseDataDetails} getExpenseData={getExpenseData} handleBackRoute={handleBackRouteToRequests} />
                              </>
                            )}
                        </div>
                      )
                    ) : (
                      <div className="esr-status-banner warning">
                        <AlertCircle size={15} />
                        Please verify all bill amounts before approval
                      </div>
                    )}

                    {(requestData.approval_status === 'pending' || requestData.approval_status === 'approved') && (
                      <div className="esr-action-group">
                        {requestData.approval_status === 'approved' && (
                          <div className="esr-status-banner info">
                            <Clock size={15} />
                            Next Stage Action Pending
                          </div>
                        )}
                        <DynamicRequestExpenseRejection i={expenseData} j={expenseDataDetails} k={requestData} getExpenseData={getExpenseData} handleBackRoute={handleBackRouteToRequests} />
                      </div>
                    )}
                  </>
                ) : (
                  <>
                    {nextStageBlocked && (
                      <div className="esr-status-banner success">
                        <CheckCircle2 size={15} />
                        Next Stage Action Performed
                      </div>
                    )}
                    {previousStagePending && (
                      <div className="esr-status-banner info">
                        <Clock size={15} />
                        Previous Stage Action Pending
                      </div>
                    )}
                    {!nextStageBlocked && !previousStagePending && (
                      <div className="esr-status-banner warning">
                        <AlertCircle size={15} />
                        Action Not Available
                      </div>
                    )}
                  </>
                )}
              </div>
            )}
          </div>
        </div>


      </div>
    </>
  );
};



export default ExpenseSlipByRequest